// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var merchantReconciliationRouter = {
  path: '/merchantReconciliation',
  component: Layout,
  redirect: '/merchantReconciliation/list',
  name: 'MerchantReconciliation',
  meta: {
    title: '商家对账',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/merchantReconciliation/list/index');
    },
    name: 'MerchantReconciliationList',
    meta: {
      title: '对账列表',
      icon: ''
    }
  }]
};
export default merchantReconciliationRouter;